module.exports = __webpack_public_path__ + "static/Award3-7f53122ced676ec5e216b1c1ba470926.jpg";